import { useLocalSearchParams, useNavigation } from 'expo-router';
import { useLayoutEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';

import { useGetUserImpact } from '@/api/hooks/donationHooks';
import { Impact } from '@/api/models/impactModels';
import GoBackButton from '@/components/buttons/GoBackButton';
import ImpactMapWeb from '@/components/impact/ImpactMapWeb';
import ImpactPopUp from '@/components/impact/ImpactPopUp';
import TotalImpact from '@/components/impact/TotalImpact';
import Title from '@/components/Title';
import { i18n } from '@/utils/i18n';

const Map = () => {
  const navigation = useNavigation();
  const { npoType } = useLocalSearchParams<{ npoType: 'charity' | 'church' }>();

  const { data } = useGetUserImpact({ npoType: npoType, periodTime: 'all' });

  const [showDonation, setShowDonation] = useState<boolean>(false);
  const [currentDonation, setCurrentDonation] = useState<Impact | null>(null);

  //Locales
  const charities_title = i18n.t('home.charities');
  const churches_title = i18n.t('home.churches');
  const total_allTime = i18n.t('profile.impact.total_allTime_impact');
  const titleScreen = npoType === 'charity' ? charities_title : churches_title;

  useLayoutEffect(() => {
    navigation.setOptions({
      headerShown: true,
      headerShadowVisible: false,
      headerBackVisible: false,
      headerTitle: () => <Title label={titleScreen} />,
      headerLeft: () => <GoBackButton />
    });
  }, [npoType, navigation, titleScreen]);

  const handleDonationPress = (item: Impact) => {
    setCurrentDonation(item);
    setShowDonation(true);
  };

  return (
    <View style={styles.container}>
      <TotalImpact text={total_allTime} amount={data?.totalAmount ?? 0} />
      {currentDonation && (
        <ImpactPopUp data={currentDonation} showPopUp={showDonation} dismissPopUp={() => setShowDonation(false)} />
      )}
      <ImpactMapWeb showDonation={handleDonationPress} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1
  }
});

export default Map;